import React, { useState, useEffect } from 'react';
import { useTheme } from '@mui/joy';
import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import eventActions from 'actions/eventActions'
import observationActions from 'actions/observationActions'
import noteActions from 'actions/noteActions'

import Sheet from 'components/core/Sheet';
import Button from 'components/core/Button';
import Typography from 'components/core/Typography';
import Stack from 'components/core/Stack';

import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

import EventDossier from 'components/EventDossier';
import ObservationsTable from 'components/ObservationsTable';

const EventView = () => {
    const theme = useTheme();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const { eventId } = useParams();
    const event = useSelector(({ event }) => event.current);
    const observations = useSelector(({ observation }) => observation.list);
    const notes = useSelector(({ note }) => note.list);
    const pagination = useSelector(({ observation }) => observation.pagination);
    const isLoading = useSelector(({ observation }) => observation.isLoading);
    const [pageSize] = useState(20);

    const sortedObservations = observations.sort((a, b) => {
        const aDate = new Date(a.get('date') || 0);
        const bDate = new Date(b.get('date') || 0);
        return aDate - bDate;
    });

    const firstObservation = sortedObservations[0] || null;
    const lastObservation = sortedObservations[sortedObservations.length - 1] || null;

    useEffect(() => {
        dispatch(observationActions.clearList());
        
        dispatch(eventActions.get(eventId)).then((getResult) => {
            if (!getResult) return;
            const event = getResult.value
            
            dispatch(observationActions.list({ 
                event: event,
                page: 1,
                pageSize: pageSize
            }));
            
            dispatch(noteActions.list({ event: event }))
        })
    }, [eventId, dispatch]);

    useEffect(() => {
        return () => {
            dispatch(eventActions.clear());
            dispatch(observationActions.clearList());
        };
    }, [dispatch]);

    const loadMoreObservations = () => {
        if (!pagination.hasMore) return;
        
        dispatch(observationActions.list({ 
            event: event,
            page: pagination.page + 1,
            pageSize: pagination.pageSize,
            loadMore: true
        }));
    };

    if (!event) {
        return null;
    }

    return (
        <Stack
            sx={{
                alignItems: 'center',
                justifyContent: 'center',
                mx: { xs: 1, sm: 1, md: 5, lg: 10, xl: 30 }
            }}
        >
            <Sheet sx={{width: '100%', background: 'none'}}>
                <Button
                    variant="text" 
                    onClick={() => navigate(-1)}
                    sx={{ padding: 0}}
                >
                    <Stack
                        direction="row"
                        spacing={2}
                    >
                        <ArrowBackIosIcon
                            sx={{ color: 'black', fontSize: 18, mt: 2}}
                        />
                        <Typography sx={{ fontSize: 18 }}>Back</Typography>
                    </Stack>
                </Button>
            </Sheet>
            
            <EventDossier
                event={event}
                notes={notes}
                firstObservation={firstObservation}
                lastObservation={lastObservation}
            />
            
            <ObservationsTable
                observations={observations}
                eventId={eventId}
                onLoadMore={loadMoreObservations}
                hasMoreRecords={pagination.hasMore}
                isLoading={isLoading}
                totalCount={pagination.total}
            />
        </Stack>
    );
};

export default EventView;